import { render, staticRenderFns } from "./CategoryDivider.vue?vue&type=template&id=719768fc&scoped=true&"
import script from "./CategoryDivider.vue?vue&type=script&lang=js&"
export * from "./CategoryDivider.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDivider.vue?vue&type=style&index=0&id=719768fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719768fc",
  null
  
)

export default component.exports